export default {
    key: "shopDetails",
    basePath: "/shopDetails",
    exclude: false,
  };
  